import { NgModule } from '@angular/core';
import { UpdateRequirement } from '../features/requirement/req-ui/update-requirement/update-requirement';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../guards/auth-guard';
import { TradeGpt } from '../features/trade-gpt/trade-gpt-ui/trade-gpt/trade-gpt';
import { ShipmentTracking } from './shipment-tracking/shipment-tracking';

const routes: Routes = [
  {
    path: "trade-gpt",
    component: TradeGpt,
    canActivate: [AuthGuard],
  },
 
  {
    path: "shipment-details",
    component: ShipmentTracking,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: "Shipment Details",
    },
  },
  {
    path: "update-requirement/:id",
    component: UpdateRequirement,
    canActivate: [AuthGuard],
    data: { breadcrumb: "Update Requirement" }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CommonFeaturesRoutingModule { }
